import { SET_GROUP_WISE_PARTICIPANTS } from '../../constants/endpoints';
import request from './request';

const fetchGroupWiseParticipantsPerSet = async (
  accessToken,
  setId,
  spaceId
) => {
  const config = {
    method: 'get',
    url: SET_GROUP_WISE_PARTICIPANTS(setId, spaceId),
  };

  const response = await request(accessToken, config);
  return response.data;
};

export default fetchGroupWiseParticipantsPerSet;
